
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.963 24.464c0-.578-.457-1.047-1.019-1.047h-2.219c-.563 0-1.019.469-1.019 1.047s.456 1.048 1.019 1.048h2.219c.562 0 1.019-.469 1.019-1.048zm-.031-3.18V5.14c0-.632-.121-.841-.129-.85l-2.166-2.164H4.271c-1.573 0-2.024 1.019-2.095 1.7a9.159 9.159 0 00-.045.938l.028 16.519h29.773zm2.201 5.253c0 .282-.102.565-.313.753a1.74 1.74 0 01-.749.384h-11.74l-.009 2.123h3.236c.557 0 1.009.476 1.009 1.063s-.452 1.063-1.009 1.063H1.052c-.558 0-1.01-.477-1.01-1.063s.452-1.063 1.01-1.063h11.752v-2.123H3.938s-.372.033-.687-.255L.709 24.924c-.321-.379-.71-.908-.71-2.45V3.467c.044-.68.179-1.341.512-1.899C1.062.645 2.153 0 4.27 0h25.811c.281.001.55.114.747.311l2.48 2.478c.31.312.824 1.024.824 2.35v21.398zm-.053 4.323c0 .587-.452 1.063-1.01 1.063h-4.375c-.558 0-1.01-.477-1.01-1.063s.452-1.063 1.01-1.063h4.375c.558 0 1.01.476 1.01 1.063z"}})])
          )
        }
      }
    